import { Injectable, Inject, EventEmitter } from "@angular/core";
import { THEMES, ACTIVE_THEME, Theme } from "./symbols";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class ThemeService {
  themeChange = new EventEmitter<Theme>();

  constructor(
    @Inject(THEMES) public themes: Theme[],
    @Inject(ACTIVE_THEME) public theme: string, public http:HttpClient
  ) {}

  // getActiveTheme() {
  //   const theme = this.themes.find((t) => t.name === this.theme);
  //   if (!theme) {
  //     throw new Error(`Theme not found: '${this.theme}'`);
  //   }
  //   return theme;
  // }

  setTheme(name: string) {
    this.theme = name;
    this.http
      .get(`./assets/theme-css/${name !== 'light' ? 'dark' : 'light'}.json`)
      .subscribe((data: any) => {
        data.forEach(({ name, value }:any) => {
          document.documentElement.style.setProperty(`--${name}`, value);
        });
      });
    // this.themeChange.emit(this.getActiveTheme());
  }
}